import { render, staticRenderFns } from "./AirlineCreate.vue?vue&type=template&id=1a9d4656"
import script from "./AirlineCreate.vue?vue&type=script&lang=js"
export * from "./AirlineCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports